import React, { useEffect, useState } from "react";
import "./Regulations.scss";
import ReactMarkdown from "react-markdown";
import { obtenerDatos } from "services/crudFirebase";
import "dayjs/locale/es";
import dayjs from "dayjs";

const Regulations = () => {
    const [TyC, setTyC] = useState("");
    const [lastUpdateTyC, setLastUpdateTyC] = useState("");

    dayjs.locale("es");

    useEffect(() => {
        window.scrollTo(0, 0);
        reeadRegulations();
    }, []);

    const reeadRegulations = async () => {
        const data = await obtenerDatos("Regulaciones");
        setTyC(data[0].TerminosYCondiciones);
        let date = data[0].LastUpdate;
        setLastUpdateTyC(dayjs(date).format("DD MMMM YYYY"));
        console.log(date);
    };

    return (
        <div className="regulations">
            <h1>Términos y Condiciones</h1>
            <ReactMarkdown children={TyC} />
            <hr />
            <p className="regulations__updateInfo">
                Última actualización de los términos y condiciones:{" "}
                {lastUpdateTyC}.
            </p>
        </div>
    );
};

export default Regulations;
